<template>
  <div>
    <div class="columns">
      <b-field class="column is-full larger-input">
        <b-icon
          v-if="isDateTimeField"
          style="cursor: pointer"
          class="mt-2 mr-2"
          @click.native.prevent="toggleDateTime()"
          :label="!displayDateTimePicker ? 'Choose a date' : 'Choose a text'"
          :icon="!displayDateTimePicker ? 'calendar-range' : 'text-box'"
        ></b-icon>
        <b-field v-if="isDateTimeField && displayDateTimePicker" label="">
          <b-datetimepicker
            placeholder="Type or select a date..."
            v-model="selectedDate"
            :timepicker="timepicker"
            icon="calendar-today"
            editable
          >
          </b-datetimepicker>
        </b-field>
        <b-autocomplete
          v-if="isAutocompleteField && !displayDateTimePicker"
          v-model="editCellValue.value"
          :data="filteredEditCellData"
          ref="editCellValue"
          open-on-focus
          rounded
          clearable
          @select="(option) => (selected = option)"
          @keyup.native.enter="submitField"
        ></b-autocomplete>
        <b-input
          v-if="!isAutocompleteField && !displayDateTimePicker"
          v-model="editCellValue.value"
          @keyup.native.enter="submitField"
          type="text"
          ref="editCellValue"
        ></b-input>
      </b-field>
      <div class="buttons column is-full d-flex justify-content-around">
        <b-icon
          style="cursor: pointer"
          @click.native.prevent="cancelSubmit()"
          label="Cancel"
          icon="cancel"
          type="is-danger"
        ></b-icon>
        <b-icon
          style="cursor: pointer; margin-left: 12px"
          @click.native.prevent="submitField()"
          label="Finish"
          icon="check-circle-outline"
          type="is-success"
        ></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import UtilService from '../../services/util';
import {
  statusOptions,
  studentFinance,
  passingOptions,
} from '../../models/static';
import moment from 'moment';
export default {
  name: 'edit-application-cell',
  props: ['editCell'],
  data() {
    return {
      editCellValue: {
        value: null,
        fieldName: null,
        id: null,
        path: null,
        studentId: null,
      },
      selectedDate: null,
      timepicker: {
        incrementMinutes: 15,
      },
      displayDateTimePicker: false,
    };
  },
  computed: {
    filteredEditCellData() {
      let arrayToFilter = [];

      switch (this.editCellValue.path) {
        case 'status':
          arrayToFilter = statusOptions;
          break;

        case 'studentData.generalInfo.english_test':
        case 'studentData.generalInfo.interview':
          arrayToFilter = passingOptions;
          break;

        case 'studentData.generalInfo.student_finance':
          arrayToFilter = studentFinance;
          break;

        default:
          break;
      }

      return this.editCellValue.value
        ? arrayToFilter.filter((option) => {
            return (
              option
                .toString()
                .toLowerCase()
                .indexOf(this.editCellValue.value.toLowerCase()) >= 0
            );
          })
        : arrayToFilter;
    },

    isAutocompleteField() {
      return (
        this.editCellValue.path === 'status' ||
        this.editCellValue.path === 'studentData.generalInfo.student_finance' ||
        this.editCellValue.path === 'studentData.generalInfo.interview' ||
        this.editCellValue.path === 'studentData.generalInfo.english_test'
      );
    },

    isDateTimeField() {
      return (
        this.editCellValue.path === 'studentData.generalInfo.interview' ||
        this.editCellValue.path === 'studentData.generalInfo.english_test'
      );
    },
  },
  created() {
    if (this.editCell) {
      const editCell = UtilService.deepCopy(this.editCell);
      this.editCellValue = editCell;
    }

    if (this.isDateTimeField && this.editCellValue.value instanceof Date) {
      this.displayDateTimePicker = true;
    }
  },
  mounted() {
    if (this.$refs.editCellValue) {
      this.$refs.editCellValue.focus();
    }

    const parsedDate = moment(this.editCellValue.value).toDate();

    if (
      this.isDateTimeField &&
      new Date(parsedDate).toString() !== 'Invalid Date'
    ) {
      this.selectedDate = parsedDate;
      this.displayDateTimePicker = true;
    }
  },
  methods: {
    submitField() {
      if (this.displayDateTimePicker) {
        this.editCellValue.value = moment(this.selectedDate).format('LLL');
      }

      this.$emit('changedEditCellValue', this.editCellValue);
    },

    toggleDateTime() {
      this.displayDateTimePicker = !this.displayDateTimePicker;
    },

    cancelSubmit() {
      this.$emit('changedEditCellValue', null);
    },
  },
};
</script>

<style>
.larger-input input[type='text'] {
  min-width: 100px;
}
</style>
